'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'

export const WizardPanel = (props) => {
  const { children, sx = {}, onClick, collapsed } = props

  return (
    <div data-testid={props['data-testid']} style={{ position: 'relative' }}>
      <MUIStack
        data-testid="WizardPanel"
        sx={{
          transition: 'height 250ms',
          overflow: 'hidden',
          height: collapsed ? '88px' : 'auto',
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '4px',
          ...sx
        }}
        direction="column"
        onClick={onClick}
      >
        {children}
      </MUIStack>
    </div>
  )
}

WizardPanel.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
  'data-testid': PropTypes.string,
  onClick: PropTypes.func,
  collapsed: PropTypes.bool
}
